import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { FacultyFormValues } from "src/models/Faculty.model";
import ATMFilePickerWrapper from "src/components/UI/atoms/formFields/ATMFileUploader/ATMFileUploaderWrapper";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import useInstitutes from "src/hooks/useInstitute";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import { handleValidNumber } from "src/utils/validations/numberInput";

type Props = {
  formikProps: FormikProps<FacultyFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const Faculty = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  const { institutes, isDataLoading } = useInstitutes();
  const instituteOptions = institutes?.map((institute) => ({
    label: institute.instituteName,
    value: institute._id,
  }));

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD" ? "Add Faculty" : "Update Faculty"}{" "}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            name="facultyName"
            required
            value={values.facultyName}
            onChange={(e) => {
              setFieldValue("facultyName", e.target.value);
            }}
            label="Faculty Name"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="facultyCode"
            required
            value={values.facultyCode}
            onChange={(e) => {
              setFieldValue("facultyCode", e.target.value);
            }}
            label="Faculty Code"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="rank"
            required
            value={values.rank}
            onChange={(e) => {
              handleValidNumber(e) && setFieldValue("rank", e.target.value);
            }}
            label="Rank"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMMultiSelect
            isLoading={isDataLoading}
            name="institute"
            required
            value={values.institute}
            onChange={(e) => {
              setFieldValue("institute", e);
            }}
            options={instituteOptions}
            label="Institute Name"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextArea
            name="facultyDescription"
            value={values.facultyDescription}
            onChange={(e) => {
              setFieldValue("facultyDescription", e);
            }}
            label="Faculty Description"
          />
        </div>
        <ATMFilePickerWrapper
          name="facultyImage"
          label="Faculty Image"
          accept="image/*"
          onSelect={(value) => setFieldValue("facultyImage", value)}
          selectedFile={values.facultyImage}
        />
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default Faculty;
